import React from 'react';
import { flowRight } from 'lodash';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import { Tabs, TabsAlignment } from '@wix/wix-ui-tpa/cssVars';
import { connect } from '../../../../common/components/runtime-context';
import withTranslate from '../../../../common/hoc/with-translate';
import { getIsUserGuestWriter } from '../../../../common/store/auth/current-user-selectors';
import { type Actions, type AppState } from '../../../../common/types';
import {
  MY_POSTS_PAGE_TAB_DRAFTS,
  MY_POSTS_PAGE_TAB_PUBLICATIONS,
  MY_POSTS_PAGE_TAB_SUBMISSIONS,
} from '../../../constants/my-posts-page';
import { getActiveTab } from '../../../store/active-tab/active-tab-selectors';
import { classes } from './page-tabs.st.css';

export const ALIGNMENT = TabsAlignment;

type OwnProps = {
  alignment?: TabsAlignment;
};

type Props = OwnProps & ReturnType<typeof mapRuntimeToProps> & Pick<WithTranslation, 't'>;

const PageTabs: React.FC<Props> = ({
  t,
  activeTab,
  alignment = TabsAlignment.left,
  isUserGuestWriter,
  setActiveTab,
  fetchPageData,
}) => {
  const tabsByIndex = [
    MY_POSTS_PAGE_TAB_PUBLICATIONS,
    ...(isUserGuestWriter ? [MY_POSTS_PAGE_TAB_SUBMISSIONS] : []),
    MY_POSTS_PAGE_TAB_DRAFTS,
  ];
  const submissionsTab = isUserGuestWriter ? [{ title: t('tabs.submissions') }] : [];

  const handleTabClick = async (tabIndex: number) => {
    const tab = tabsByIndex[tabIndex];
    if (tab) {
      await setActiveTab(tab);
      await fetchPageData();
    }
  };

  return (
    <Tabs
      data-hook="my-posts-page-tabs"
      className={classes.root}
      items={[{ title: t('tabs.publications') }, ...submissionsTab, { title: t('tabs.drafts') }]}
      activeTabIndex={tabsByIndex.indexOf(activeTab)}
      onTabClick={handleTabClick}
      alignment={alignment}
    />
  );
};

const mapRuntimeToProps = (state: AppState, _ownProps: {}, actions: Actions) => ({
  activeTab: getActiveTab(state),
  setActiveTab: actions.setActiveTabPromisified,
  fetchPageData: actions.fetchMyPostsPageDataPromisified,
  isUserGuestWriter: getIsUserGuestWriter(state),
});

export default flowRight(withTranslate, connect(mapRuntimeToProps))(PageTabs);
